<script>
import { Pie } from 'vue-chartjs'

export default {
  extends: Pie,
  name: 'PieChart',
  props: {
    chartData: {
      type: Array,
      default() {
        return []
      }
    },
    labels: {
      type: Array,
      default() {
        return []
      }
    },
    year: {
      type: Number,
      default() {
        return 0
      }
    },
    colors: {
      type: Array,
      default() {
        return []
      }
    }
  },
  watch: {
    chartData() {
      this.getChart()
    }
  },
  mounted() {
    this.getChart()
  },
  methods: {
    getChart() {
      const allCount = this.chartData.length
        ? this.chartData.reduce((sum, elem) => sum + elem)
        : 0
      this.renderChart(
        {
          labels: this.labels,
          datasets: [
            {
              backgroundColor: this.colors,
              data: this.chartData
            }
          ]
        },
        {
          responsive: true,
          maintainAspectRatio: false,
          tooltips: {
            callbacks: {
              label: (tooltipItem, data) => {
                const dataset = data.datasets[tooltipItem.datasetIndex]
                const districtLabel = data.labels[tooltipItem.index]
                const count = dataset.data[tooltipItem.index]
                return `${districtLabel} (${this.year - 1}-${this.year}): ${count} уч.`
              }
            }
          },
          plugins: {
            datalabels: {
              color: () => 'white',
              formatter: (value, context) => {
                const count = context.chart.data.datasets[0].data[context.dataIndex]
                return count ? `${((count * 100) / allCount).toFixed(0)}%` : ''
              }
            }
          }
        }
      )
    }
  }
}
</script>
